import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Validators, FormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { cgpAuthentication } from '../../../../modules/cgp-authentication';
import { BaseGridTemplate } from '../../../shared/cgp-grid/base-cgp-grid.template';
import { Tool } from '../../../shared/domain/tnt/Tool';
import { ToolFilterManager } from './tool-filter-manager'
import { TntToolStateService } from './tnt-tool-state.service'
import { TntToolUsageComponent } from './create-tool-usage.component';
import { TntToolVersionComponent } from './create-tool-version.component';
import { CgpSnackbarService } from '../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpGridComponent } from '../../../shared/cgp-grid/cgp-grid.component';
import { CgpConfirmationDialogService } from '../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { takeUntil } from 'rxjs/operators';


import {
  TntToolService,
  TntToolTypeService,
  TntSystemService,
  ApplicationService,
  TntToolReferenceFileService,
  TntToolOwnerService,
} from '../tnt.service';

import {
  BaseService,
  GlobalRegionService,
  CenterService,
  ZoneService,
  SubZoneTitleService,
  ToolHandednessService,
  UserService,
} from '../../mesc/mesc.service';

import { AuthenticationService } from '../../../auth.service';
import { S3Service } from '../../../shared/s3.service';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-create-tool',
  templateUrl: './create-tool.component.html',
  styleUrls: ['./create-tool.component.scss'],
  // host: { 'class': 'inline-flex' },
  providers: [
    ToolFilterManager,
    TntToolUsageComponent,
    TntToolVersionComponent,
    TntToolStateService
  ],
})
export class CreateToolComponent extends BaseGridTemplate implements OnInit, OnDestroy {

  dataItem: any;
  gridState: boolean;
  isNew: boolean;
  isCreateUpdate: boolean;
  formTitle: Subject<string> = new BehaviorSubject<string>("");
  isFilterByUser: Subject<boolean> = new BehaviorSubject<boolean>(true);
  addDialogTitle: Subject<string> = new BehaviorSubject<string>("");
  toolState: Subject<any[]> = new BehaviorSubject<any[]>([]);
  loggedInUser: number = 0;
  usageFormControl: any = this.toolUsageComponent.usageFormControl;
  toolsData: Subject<any> = new BehaviorSubject<any>(null);
  month = new Date().getMonth() + 1;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  bodyShopId: string;
  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;
  isAdmin: boolean;
  canEdit: boolean = true;
  private readonly userInfo: any = cgpAuthentication.getUserInfo();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  constructor(
    private formBuilder: FormBuilder,
    private baseService: BaseService,
    private toolOwnerService: TntToolOwnerService,
    private toolService: TntToolService,
    private toolTypeService: TntToolTypeService,
    private applicationService: ApplicationService,
    private tntSystemService: TntSystemService,
    private centerService: CenterService,
    private globalRegionService: GlobalRegionService,
    private tntToolReferenceFileService: TntToolReferenceFileService,
    private userService: UserService,
    private toolHandednessService: ToolHandednessService,
    private zoneService: ZoneService,
    private subZoneService: SubZoneTitleService,
    public toolFilterService: ToolFilterManager,
    private toolUsageComponent: TntToolUsageComponent,
    private toolVersionComponent: TntToolVersionComponent,
    private toolEditDataItem: TntToolStateService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private cgpConfirmationDialogService: CgpConfirmationDialogService,
    private authService: AuthenticationService,
    private readonly s3Service: S3Service
  ) {
    super();
    var self = this;
    this.centerService.read("", true).then(function (response) {
      self.bodyShopId = response.filter(function (center) {
        return center.Description.toUpperCase() === "BODY SHOP";
      })[0].Id;
    })
    this.globalRegionService.query();
    this.toolHandednessService.query();
    this.zoneService.query();
  }


  ngOnInit() {
    this.isFilterByUser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(isSelected => {
        this.userFilterButton.selected = isSelected;
      });
    this.loggedInUser = parseInt(this.userInfo.gmuniqueidentifier || this.userInfo.gmin);

    this.toolEditDataItem.state$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state) => this.dataItem = state);
    this.toolEditDataItem.get();
    this.zoneService.subscribe(zones => zones.map(x => x.ZoneDescription = x.Description + ' - ' + x.DetailDescription))

    this.subZoneService.subscribe(data => data.map(x => x.Description = x.SubZone + ' - ' + x.Title))

    this.isAdmin = this.authService.isClaimValid("/MESC/TNTS/Administration");
  }


  /**
   * Toggles the 'My Tools' button on and off
   */
  toggleToolsByUser = () => {
    this.grid.resetState();
    this.isFilterByUser.next(!this.userFilterButton.selected);
    this.userFilterButton.selected ?
      this.toolFilterService.reset() :
      this.toolFilterService.restore();
  }


  /**
   * Add controls based on the type of Center selected
   * @param isBodyShop selected center type: true if equals 'Body Shop' false otherwise
   */
  updateEditForm(isBodyShop: boolean = false) {

    if (isBodyShop) {
      this.editForm.addControl('ZoneId', new FormControl("", Validators.required));
      this.editForm.addControl('SubZoneId', new FormControl("", Validators.required));
      this.editForm.get('SubZoneId').disable();
    } else {
      this.editForm.addControl('SystemId', new FormControl("", Validators.required))
      this.editForm.addControl('ApplicationId', new FormControl("", Validators.required))
      this.editForm.addControl('ToolTypeId', new FormControl("", Validators.required))
      this.editForm.get('ApplicationId').disable();
      this.editForm.get('ToolTypeId').disable();
    }
  }


  /**
   * Reset the editForm controls based on the Center value
   * If a center is selected, call updateEditForm
   * @param CenterId: the Id of the selected Center
   */
  handleCenterChange = (CenterId: string = "") => {
    this.editForm.removeControl('SystemId');
    this.editForm.removeControl('ApplicationId');
    this.editForm.removeControl('ToolTypeId');
    this.editForm.removeControl('ZoneId');
    this.editForm.removeControl('SubZoneId');

    try {
      let center = this.centerService.data
        .find(center => CenterId === center.Id)
      let isBodyShop = center ? center.Description === 'Body Shop' : false;
      if (center) this.updateEditForm(isBodyShop);
      if (CenterId && !isBodyShop) {
        this.tntSystemService.read('/Center/' + CenterId, true)
      }
    } catch (e) {
      console.error('HandleCenterChange Exception::', e);
    }
  }


  /**
   * If the 'My Tools' button is selected, return the query path for the users tools,
   * otherwise return all tools
   */
  getSearchParams(state) {
    return this.toolFilterService.getFilters(state);
  }


  /**
   * CgpGrid (read) callback
   */
  handleRead = (force, dataItem, gridState): Promise<any> => {
    var self = this;
    if (this.toolFilterService.isFilterSet) {
      this.isFilterByUser.next(false);
    }

    if (!this.userFilterButton.selected) {
      let params = this.getSearchParams(gridState);

      return this.baseService.post(params.filters, params.urlExtension, params.fieldName)
        .then(data => {
          this.baseService.loading.next(false);
          return <GridDataResult>{
            data: data.TntTools,
            total: data.RecordCount
          }
        })
        .catch(e => this.baseService.loading.next(false));
    }

    let orderBy: string = '';
    let sortOrder: string = '';
    if (gridState.sort && gridState.sort.length && gridState.sort[0].dir) {
      orderBy = '&orderBy=' + gridState.sort[0].field;
      sortOrder = '&sortOrder=' + gridState.sort[0].dir;
    }

    let page = gridState.skip ? (gridState.skip / gridState.take) + 1 : 1;
    let urlExtension = "tnt/tool/search?" +
      "pageSize=" + gridState.take +
      '&pageNumber=' + page +
      orderBy + sortOrder,
      fieldName = "TntTools";

    var userFilters = {
      OwnerGmin: parseInt(this.userInfo.gmuniqueidentifier || this.userInfo.gmin)
    }

    return this.baseService.post(userFilters, urlExtension, fieldName)
      .then(function (data) {
        self.baseService.loading.next(false);
        return <GridDataResult>{
          data: data.TntTools,
          total: data.RecordCount
        }
      })

    // return this.toolOwnerService.read('/' + this.loggedInUser + '/Tool', true)
  }


  presetComboboxes() {
    let globalRegion = this.globalRegionService.value.find(x => x.Description === 'GMNA');
    let regionId = globalRegion ? globalRegion.Id : "";
    this.editForm.get("GlobalRegionId").setValue(regionId);
    this.toolUsageComponent.handleRegionChange(regionId);
    let center = this.centerService.value.find(x => x.Description === 'Body Shop');
    let centerId = center ? center.Id : "";
    this.editForm.get("CenterId").setValue(centerId);
    this.handleCenterChange(centerId);
  }


  /**
   * CgpGrid (add) callback
   * If the dataItem is defined then get the tool details from the server and
   * update the formControls and fields to add a new version for the tool otherwise
   * if there is no dataItem, then update the formControls and fields for a new Tool
   * @param dataItem Tool editDataItem
   */
  setModelHandler(dataItem: any = undefined): void {
    if (dataItem) {
      this.addToolVersion(dataItem);
    } else {
      this.resetForm();
      this.isCreateUpdate = true;
      this.isNew = true;
      let editDataItem: Tool;
      this.editForm.addControl('toolCount', new FormControl(1, Validators.required))
      this.handleCenterChange();
      editDataItem = new Tool();
      editDataItem.OwnerGmin = this.loggedInUser;
      editDataItem.IsActive = true;
      this.toolEditDataItem.set(editDataItem);
      this.toolUsageComponent.updateUsageForm(true);
      this.editForm.reset(editDataItem);
      this.presetComboboxes();
      this.formTitle.next('Add New Tool');
    }
  }


  /**
   * CgpGrid (edit) callback
   * Update the form dialog based on the detailRow
   * @param dataItem Tool editDataItem
   * @param isDetailRow selected dataItem is from a detail row (Tool Version)
   */
  handleEdit = (dataItem, isDetailRow) => {
    this.grid.closeDialog();
    this.resetForm();

    this.setEditDataItemDetails(dataItem)
      .then(response => {
        this.isCreateUpdate = true;
        this.dataItem = response;
        let owner: number = parseInt(this.dataItem.OwnerGmin);
        this.canEdit = this.isAdmin || owner == this.loggedInUser;


        this.formTitle.next((this.canEdit ? 'Edit ' : 'Viewing ') + 'Tool# ' + dataItem.ToolNumber);
        this.editForm.reset(this.dataItem);
        this.cascadeDropdowns(this.dataItem);
        this.toolUsageComponent.updateUsageForm(false);
        if (!this.canEdit) {
          this.editForm.disable();
        }

        if (isDetailRow) {
          this.editForm.get('ToolHandednessId').disable();
        } else if (this.canEdit) {
          this.editForm.get('ToolHandednessId').enable();
        }
      });

    this.editForm.removeControl('toolCount');
  }


  cascadeDropdowns(dataItem) {
    if (dataItem.ZoneId) {
      this.handleZoneChange(dataItem.ZoneId);
    } else {
      this.handleSystemChange(dataItem.SystemId);
      this.handleApplicationChange(dataItem.ApplicationId);
    }
  }


  resetDropDowns() {
    this.subZoneService.reset();
    this.applicationService.reset();
    this.toolTypeService.reset();
  }


  /**
   * CgpGrid (delete) callback
   */
  handleDelete = (dataItem) => {
    return this.toolService.remove('/' + dataItem.Id, false)
      .catch(x => {
        this.grid.refresh(true);
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: "This tool has tool versions. You must remove all versions for this tool before you can delete it.",
          alert: 'danger',
          closeLabel: 'Close',
        })
      });
  }


  /**
   * CgpGrid (save) callback
   */
  handleSave = (data, isNew, isDetailRow): Promise<any> => {
    let urlExtension: string;
    var self = this;
    if (!data.OwnerGmin) {
      data.OwnerGmin = this.loggedInUser;
    }

    this.resetDropDowns();
    if (isNew && !isDetailRow) delete data.ToolNumber;

    if (isDetailRow && isNew) {
      urlExtension = "/version?toolId=" + data.Id;
      return this.toolService.save(data, isNew, urlExtension, false)
        .then(response => {
          self.grid.refresh(true);
        });
    } else {
      let toolCount = data.toolCount;
      delete data.toolCount;
      if (isNew && this.selectedFiles) {
        data.ReferenceFiles = this.selectedFiles.map(file => {
          return {
            FileReferenceName: file.name,
            RelativePath: ''
          }
        });
      }

      urlExtension = isNew ? ("?toolCount=" + toolCount) : "";
      return this.toolService.save(data, isNew, urlExtension)
        .then(response => {
          if (isNew && this.selectedFiles) {
            if (response) {
              this.dataItem = response.body;
              this.uploadFiles(isNew);
            }
          }
          this.grid.refresh(true);
        });
    }

  }



  /**
   * CGP Grid show control callback
   */
  showControl = (name: string, dataItem: any): boolean => {
    let isAdmin: boolean = this.authService.isClaimValid("/MESC/TNTS/Administration");
    let currentUser: number = parseInt(this.userInfo.gmuniqueidentifier || this.userInfo.gmin);
    let isShow: boolean = true;
    switch (name) {
      case 'gridClearFilter':
        isShow = this.toolFilterService.isFilterSet;
        break;
    }
    return isShow;
  }



  /**
   * Query service using the dataItem Id
   * Update tool usages for the selected dataItem
   * Update the form dialog controls and fields
   * Set the form editDataItem to the selected dataItem
   * @param dataItem selected dataItem to edit
   */
  setEditDataItemDetails(dataItem): Promise<any> {
    return this.toolService.read('/' + dataItem.Id, true)
      .then(detail => {
        try {
          detail.ToolUsages.map(usage => usage.ToolId = detail.Id);
          if (!detail.ReferenceFiles) detail.ReferenceFiles = [];
          detail.ReferenceFiles.map(file => file.name = file.FileReferenceName);
        } catch (e) { }

        this.handleCenterChange(detail.CenterId);
        this.toolUsageComponent.handleRegionChange(detail.GlobalRegionId);
        let center = this.centerService.data
          .find(item => item.Id === detail.CenterId);
        if (center) this.updateEditForm(center.Description === 'Body Shop');
        if (!detail.ReferenceFiles) detail.ReferenceFiles = [];
        this.toolEditDataItem.set(detail);
        return detail;
      })
  }


  /**
   * If systemId is defined, query for applications under that system
   * otherwise reset application service to an empty list
   */
  handleSystemChange = (systemId: string) => {
    let appCtrl = this.editForm.get('ApplicationId');
    if (!appCtrl) return;
    if (systemId) {
      this.applicationService.query('/System/' + systemId);
      appCtrl.enable();
    } else {
      appCtrl.disable();
      appCtrl.setValue(undefined);
      this.handleApplicationChange(undefined);
      this.applicationService.reset();
    }
  }


  /**
   * If appId is defined, query for ToolTypes under that application
   * otherwise reset ToolTypes service to an empty list
   */
  handleApplicationChange = (appId: string) => {
    let toolTypeCtrl = this.editForm.get('ToolTypeId');
    if (!toolTypeCtrl) return;

    if (appId) {
      this.toolTypeService.query('/Application/' + appId);
      toolTypeCtrl.enable();
    } else {
      toolTypeCtrl.disable();
      toolTypeCtrl.setValue(undefined);
      this.toolTypeService.reset();
    }
  }


  /**
   * If zoneId is defined, query for SubZones under that Zone
   * otherwise reset Zones service to an empty list
   */
  handleZoneChange = (zoneId: string) => {
    let subZoneCtrl = this.editForm.get('SubZoneId');
    if (!subZoneCtrl) return;

    if (zoneId) {
      this.subZoneService.query(zoneId + '/subzonetitle?$filter=IsActive eq true and CenterId eq ' + this.bodyShopId, false)
      subZoneCtrl.enable();
    } else {
      subZoneCtrl.disable();
      subZoneCtrl.setValue(undefined);
      this.subZoneService.reset();
    }
  }


  /**
   * Archive Tools
   */
  handleArchiveTool = (): void => {
    let _toolId = this.dataItem.Id;

    this.cgpConfirmationDialogService.showConfirmationDialog({
      title: 'Archive Tool Confirmation',
      message: 'Are you sure that you want to Archive this Tool? ' + this.dataItem.ToolNumber,
      alert: 'warning',
      onYesClick: () => {
        this.cgpConfirmationDialogService.closeConfirmationDialog();
        this.toolService
          .save(null, false, '/archive?toolId=' + _toolId, false, false, false)
          .then(() => {
            this.isCreateUpdate = false;
            this.dataItem.isArchived = true;
            this.grid.refresh(true);
          })
          .catch(x => {
            this.cgpAlertDialogService.showAlertDialog({
              title: x.status + ' Error',
              message: x._body ? x._body.replace(/["{}]/g, '').replace(/message:/i, "") : '',
              alert: 'danger',
              closeLabel: 'Close',
            })
          });
      },
      onNoClick: () => {
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      }
    });



  }

  isShowArchiveButton = (isNew: boolean, control: any): boolean => {

    return !isNew && this.dataItem && this.dataItem.CanArchive;
  }

  archiveToolsControl = {
    type: "action",
    show: this.isShowArchiveButton,
    name: 'CanArchive',
    title: "Archive Tool",
    iconClass: "fa fa-wrench  fa-fw",
    isPrimary: true,
    refresh: true,
    close: true,
    callback: this.handleArchiveTool,
  }


  /****************************************************************************
     * Upload Handlers
  ***************************************************************************/

  selectedFiles: any[];
  onSelectFile = (control: any, e: any) => {
    this.selectedFiles = e.files;
    if (!this.isNew) this.uploadFiles();
  }

  refreshReferenceFiles() {
    let ctrl = this.editForm.get('ReferenceFiles');
    ctrl.reset();
    this.tntToolReferenceFileService.read('/' + this.dataItem.Id, true)
      .then(ref => {
        ref.map(file => file.name = file.FileReferenceName);
        ctrl.setValue(ref)
      });
  }

  uploadFiles(isNew = false) {
    const _path = `TNT/${this.dataItem.ToolNumber}/`;
    const uploadResponses: Promise<any>[] = [];
    this.s3Service.handleS3Upload(this.selectedFiles, _path)
      .then(x => {
        this.selectedFiles.forEach(f => {
          if (!this.dataItem.ReferenceFiles.some(x => x.Id === f.uid)) {
            const _file = {
              TntToolId: this.dataItem.Id,
              FileReferenceName: f.name,
            }

            if (!isNew) {
              uploadResponses.push(this.tntToolReferenceFileService.save(_file, true, ''));
            }
          }
        });
        Promise.all(uploadResponses)
          .then(() => this.refreshReferenceFiles());
      })
      .catch(x => this.refreshReferenceFiles());
  }

  onRemoveFile = (file) => {
    let ctrl = this.editForm.get('ReferenceFiles');
    if (this.isNew) {
      let index = this.selectedFiles.findIndex(x => x.uid === file.uid);
      this.selectedFiles.splice(index, 1);
      ctrl.setValue(this.selectedFiles);
    } else {
      let newFiles = ctrl.value.filter(x => x.Id !== file.Id);
      ctrl.setValue(newFiles);

      const _path = `TNT/${this.dataItem.ToolNumber}/`;

      if (file.Id) this.tntToolReferenceFileService.remove('?toolReferenceId=' + file.Id)
        .then(x => {
          this.s3Service.handleS3Remove(file, _path);
          return x;
        })
        .catch(e => null);
    }
  }

  downloadReferenceFile(file: any) {
    const _path = `TNT/${this.dataItem.ToolNumber}/`;
    this.s3Service.downloadS3Object(file, _path);
  }

  onClearFile = (e) => {
    console.log(e);
  }

  /****************************************************************************
   * Excel Export
  ***************************************************************************/
  onExport = () => {
    var self = this;
    var filters = this.toolFilterService.getFilters(this.state);

    if (this.userFilterButton.selected) {
      filters.filters = null;
      let page = this.state.skip ? (this.state.skip / this.state.take) + 1 : 1;

      filters.urlExtension = "tnt/tool/search?" + "pageSize=" + this.state.take + "&pageNumber=" + page;
      filters.filters = {
        OwnerGmin: parseInt(this.userInfo.gmuniqueidentifier || this.userInfo.gmin)
      }
    }

    if (filters.filters !== null) {
      this.baseService.save(filters.filters, true, filters.urlExtension + "&export=true", false, false, false, 2).then(function (response) {
        var blob = new Blob([response._body], { type: "application/vnd.ms-excel" });
        var fileName = "Tools_" + cgpAuthentication.getUserInfo().sn + "_" + new Date().getDate() + "-" + self.month + "-" + new Date().getFullYear() + ".xlsx";
        var a = window.document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = fileName;
        document.body.appendChild(a)
        a.click();
        self.baseService.loading.next(false);
      }).catch(function (response) {
        self.baseService.loading.next(false);
      })
    }
    else {
      this.cgpAlertDialogService.showAlertDialog({
        message: "Please select at least one filter before exporting",
        title: "Error",
        alert: "danger",
        closeLabel: "OK"
      })
    }

  }

  /****************************************************************************
   * Schemas
   ***************************************************************************/

  // Custom Filter
  gridFilterButton = {
    id: "gridFilter",
    iconClass: "fa fa-filter",
    class: "filter-button",
    title: "Filter Tools",
    text: "Filter Tools",
    callback: this.toolFilterService.handleGridFilter,
  }

  // Custom FilterClear
  clearFilter = () => {
    this.toolFilterService.reset(true);
    this.refresh();
  }
  gridFilterClearButton = {
    id: "gridClearFilter",
    class: "clear-button",
    bare: true,
    title: "Clear all Filters",
    text: "Clear",
    primary: true,
    callback: this.clearFilter,
  }



  // Custom Toolbar Buttons
  userFilterButton = {
    id: "filterToolsByCurrentUser",
    iconClass: "fa fa-filter",
    title: "Filter my Tools",
    text: "My Tools",
    bare: false,
    togglable: true,
    primary: false,
    selected: true,
    refresh: true,
    callback: this.toggleToolsByUser,
  }

  //Custom Export Button 
  exportToExcelButton = {
    id: "exportTntsTools",
    iconClass: "fa fa-file-excel-o",
    title: "Export To Excel",
    text: "Export to Excel",
    primary: false,
    callback: this.onExport
  }

  // Grid Columns
  columns = [
    {
      field: 'ToolNumber',
      title: 'Tool Number',
      width: 120,
    },
    {
      field: 'Ownername',
      title: 'Tool Owner',
      // template: {
      //   type: 'user',
      //   service: this.userService
      // },
      // width: 200
    },
    {
      field: 'CenterName',
      title: 'Center',
      width: 140
    },
    {
      field: 'RegionName',
      title: 'Region',
      width: 80
    },
    {
      field: 'ToolDescription',
      title: 'Description',
    },
    {
      field: 'ToolComment',
      title: 'Comment',
    },
    {
      field: 'TeamCenterLink',
      title: 'Team Center Link',
      sortable: false,
      template: {
        type: 'link'
      }
    },
    {
      field: 'CreatedDate',
      title: 'Created Date',
      width: 85,
      template: {
        type: 'date',
        dateFormat: 'shortDate'
      }
    },
  ]

  state = {
    sort: [],
    skip: 0,
    take: 150,
    group: []
  }

  // Template
  template = {
    title: "TNTS Tools",
    controls: {
      add: true,
      edit: true,
      delete: false,
      excel: true,
      customToolbar: [
        // this.exportToExcelButton,
        this.userFilterButton,
        this.gridFilterButton,
        this.gridFilterClearButton,
      ],
    },
    showControl: this.showControl,
    pageSizes: [25, 50, 100, 150, 200, 500],
    read: this.handleRead,
    save: this.handleSave,
    edit: this.handleEdit,
    groupable: false,
    fileName: "Tools_" + cgpAuthentication.getUserInfo().sn + "_" + new Date().getDate() + "-" + this.month + "-" + new Date().getFullYear() + ".xlsx",
    filterTemplate: this.toolFilterService.toolFilterTemplate,
    columns: this.columns,
    service: this.baseService,
    detailTemplate: this.toolVersionComponent.toolVersionTemplate,
    state: this.state,
    onExport: this.onExport
  }

  // Grid Edit Form (TNTS Tool)
  editForm: UntypedFormGroup = this.formBuilder.group({
    ToolDescription: ['', Validators.required],
    GlobalRegionId: ['', Validators.required],
    ToolHandednessId: ['', Validators.required],
    IsActive: [true],
    isSpecialHandTool: [false],
    CenterId: ['', Validators.required],
    ToolComment: [''],
    OwnerGmin: [0],
    ReferenceFiles: [[]],
    ToolUsages: [[]],

    TeamCenterLink: [''],  // missing
    ReferenceLinkName: [''],  // missing
    ReferenceLinkURL: [''],  // missing
    CanArchive: [],
    ToolNumber: [],
    ParentId: [],

    Id: [],
    CreatedDate: [],
  })

  // Grid Edit Form Dialog(TNTS Tool)
  formDialog = {
    title: this.addDialogTitle,
    tabs: [
      {
        title: "General",
        selected: true,
        style: 'left',
        columnClass: 'flex-wrap-column col-size-4',
        editForm: this.editForm,
        formControls: [
          {
            type: "combobox",
            name: "GlobalRegionId",
            title: "Region",
            readonly: "update",
            onChange: this.toolUsageComponent.handleRegionChange,
            placeholder: "Select a region...",
            textField: "Description",
            valueField: "Id",
            service: this.globalRegionService,
          },
          {
            type: "user",
            title: "Tool Owner",
            name: "OwnerGmin",
            data: cgpAuthentication.getUserInfo()
          },
          {
            type: "combobox",
            name: "CenterId",
            title: "Center",
            readonly: "update",
            onChange: this.handleCenterChange,
            placeholder: "Select a Center...",
            textField: "Description",
            valueField: "Id",
            service: this.centerService,
          },
          {
            type: "combobox",
            name: "SystemId",
            title: "System",
            placeholder: "Select a System...",
            textField: "Description",
            valueField: "Id",
            onChange: this.handleSystemChange,
            service: this.tntSystemService,
          },
          {
            type: "combobox",
            name: "ApplicationId",
            title: "Application",
            placeholder: "Select an Application...",
            textField: "Description",
            valueField: "Id",
            onChange: this.handleApplicationChange,
            service: this.applicationService,
          },
          {
            type: "combobox",
            name: "ToolTypeId",
            title: "Tool Type",
            placeholder: "Select a Tool Type...",
            textField: "Description",
            valueField: "Id",
            service: this.toolTypeService,
          },
          {
            type: "combobox",
            name: "ZoneId",
            title: "Zone",
            placeholder: "Select a Zone...",
            textField: "ZoneDescription",
            valueField: "Id",
            onChange: this.handleZoneChange,
            service: this.zoneService,
          },
          {
            type: "combobox",
            name: "SubZoneId",
            title: "Sub Zone",
            placeholder: "Select a Sub Zone...",
            textField: "Description",
            valueField: "SubZoneId",
            service: this.subZoneService,
          },
          {
            type: "combobox",
            name: "ToolHandednessId",
            title: "Handedness",
            placeholder: "Select Handedness...",
            textField: "Description",
            valueField: "Id",
            service: this.toolHandednessService,
          },
          {
            type: "text",
            name: "ToolDescription",
            title: "Description (40 chars. max)",
            maxlength: 40,
          },
          {
            type: "textarea",
            name: "ToolComment",
            title: "Comments",
            maxlength: 1000
          },
          {
            type: "number",
            name: "toolCount",
            title: "Number of Tools",
            minimum: 1,
            maximum: 999,
            hoverTitle: "Please only enter multiple tools when blocking large amounts of tool numbers"
          },
          {
            type: "boolean",
            name: "isSpecialHandTool",
            title: "Special / Handtool ?",
          },
          this.archiveToolsControl,
        ],
      },
      this.usageFormControl,
      {
        title: "Reference",
        selected: false,
        editForm: this.editForm,
        formControls: [
          {
            type: "text",
            name: "TeamCenterLink",
            title: "Team Center Link",
            maxlength: 250
          },
          {
            type: "text",
            name: "ReferenceLinkName",
            title: "Reference Link Name",
            maxlength: 250
          },
          {
            type: "text",
            name: "ReferenceLinkURL",
            title: "Reference Link URL",
            maxlength: 250
          },
          {
            type: "upload",
            title: "Reference Files",
            name: "ReferenceFiles",
            service: this.tntToolReferenceFileService,
            uploadSaveUrl: this.tntToolReferenceFileService.BASE_URL + "tnt/toolreferencefile/upload",
            autoUpload: false,
            removeUrl: '/api/tnt/ToolReferenceFile',
            removeMethod: 'DELETE'
          }
        ],
      },
    ]
  }


  isReadOnly = (control: any): boolean => {
    let readonly: boolean;
    if (control && control.readonly) {
      switch (control.readonly) {
        case 'create':
          // readonly = this.template.isNew;
          break;
        case 'update':
          // readonly = !this.template.isNew;
          break;
        case 'always':
          readonly = true;
          break;
        default:
          break;
      }
    }
    return readonly;
  }

  isShowControl = (control: any, check: string = undefined, editForm): boolean => {
    try {
      return (check ? control.type === check : true) &&
        editForm.controls[control.name] !== undefined;
    } catch (e) {
      return false;
    }
  }


  resetForm() {
    this.isNew = false;
    this.isCreateUpdate = false;
    this.editDataItem = undefined;
    this.toolUsageComponent.resetForm();
    this.toolEditDataItem.set(undefined);
    this.isNew = false;
    this.editForm.removeControl('SystemId');
    this.editForm.removeControl('ApplicationId');
    this.editForm.removeControl('ToolTypeId');
    this.editForm.removeControl('ZoneId');
    this.editForm.removeControl('SubZoneId');
    this.editForm.reset();
    this.editForm.enable();
    this.canEdit = true;
  }

  onCancel = (e) => {
    this.resetForm();
  }

  onSave = (isRemoveFile = false): Promise<any> => {
    this.editForm.enable();
    let usage = this.toolUsageComponent.editForm.value;
    if (!usage.CreatedBy) usage.CreatedBy = this.userInfo.gmuniqueidentifier || this.userInfo.gmin;
    let usageFormControl = this.editForm.get('ToolUsages');

    if (this.isNew) {
      usageFormControl.setValue([usage]);
    } else {
      usageFormControl.setValue(this.toolUsageComponent.usages);
    }

    let response = this.handleSave(this.editForm.value, this.isNew, null);

    if (!isRemoveFile) {
      this.handleResponse(response, this.isNew ? 'Record has been created' : 'Record has been updated');
      this.resetForm();
    }
    return response;
  }

  handleResponse = (response: Promise<any>, messageText: string) => {
    if (!response) return;
    response.then(x => {
      this.cgpSnackbarService.showSnackbar({
        message: messageText,
        duration: 2000
      });
    }).catch(x => {
      if (x.message) x._body = x.message;
      this.cgpAlertDialogService.showAlertDialog({
        title: 'Error',
        message: x._body ? x._body.replace(/"/g, '') : '',
        alert: 'danger',
        closeLabel: 'Close',
      })
    });
  }

  isFormValid(): boolean {
    let toolFormValid = this.editForm.valid;
    let usageFormValid = this.toolUsageComponent.editForm.valid;
    return this.isNew ?
      toolFormValid && this.toolUsageComponent.editForm.valid :
      this.canEdit ? toolFormValid && !this.toolUsageComponent.isEditPanelBarItem :
        !this.toolUsageComponent.isEditPanelBarItem;
  }

  filter = (dataItem) => {
    this.toolFilterService.filter(dataItem);
    this.refresh();
  }

  refresh() {
    this.gridState = !this.gridState;
  }

  getStyle = (tab): any => {
    return ((window.innerWidth - window.innerWidth * 0.06 >= 1366) && tab.style) ?
      { 'float': tab.style } :
      !tab.style ? { 'margin-bottom': '80px' } : null;
  }


  cleanUpVersionData = (dataItem): any => {
    delete dataItem.TeamCenterLink;
    delete dataItem.ToolComment;
    delete dataItem.ReferenceLinkName;
    delete dataItem.ReferenceLinkURL;
    delete dataItem.ReferenceFiles;
    dataItem.isSpecialHandTool = false;
    dataItem.ToolUsages.map(x => {
      delete x.Station;
      delete x.DesignSource;
      delete x.BuildSource;
      delete x.UserId
      x.CreatedBy = this.loggedInUser;
      return x;
    })
    dataItem.OwnerGmin = this.loggedInUser;
    dataItem.UserId = this.userService.value.find(x => x.GMIN === this.loggedInUser).Id;
    return dataItem;
  }


  addToolVersion(dataItem) {

    this.cgpConfirmationDialogService.showConfirmationDialog({
      title: 'Add Tool Version Confirmation',
      message: 'Are you sure that you want to add a new Tool Version?',
      alert: 'warning',
      onYesClick: () => {
        this.toolService.read('/' + dataItem.Id, true)
          .then(parent => {
            let data = this.cleanUpVersionData(parent);
            this.handleSave(data, true, true)
          });
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      },
      onNoClick: () => {
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      }
    });
  }

  getControlClass = (control: any, form: any) => {
    if (this.isShowControl(control, null, form)) {
      return 'k-form-inline';
    }
  }


  canEditUsage = (dataItem: any): boolean => {
    if (dataItem) {
      let usages = this.toolUsageComponent.editDataItem['ToolUsages'];
      let item = usages[dataItem.id]
      return this.canEdit || parseInt(item.CreatedBy) == this.loggedInUser
    }
    return false;
  }

}
